<div class="">

    <div class="accordion accordion-flush fixed-top" style="margin-top: 56px;" id="accordionFlushExample">
        <div class="accordion-item border border-primary" >
          <h2 class="accordion-header" id="flush-headingOne">
            <button class="accordion-button collapsed bg-dark text-white px-4" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
              {{ 'scanner.camera' | translate }}
            </button>
          </h2>
        </div>
        <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
            <div class="accordion-body bg-dark text-white container">
              <ul class="list-group-flush bg-dark text-white p-0 m-0">
                <li class="list-group-item bg-dark text-white" style="font-size: 13px;"  (click)="changeCamera(undefined)">No device</li>
                <li *ngFor="let camera of devices; index as i" style="font-size: 13px;" class="list-group-item bg-dark mt-3" (click)="changeCamera(camera)" [ngClass]="scanner.device===camera ? 'text-warning fw-bold' : 'text-white'">
                    #{{i+1}} - {{ camera.label }}
                </li>
              </ul>
            </div>
          </div>
    </div>

    <div>

    <zxing-scanner #scanner
        [enable]="true"
        [formats]="allowedFormats"
        previewFitMode="cover"
        (scanSuccess)="scanSuccessHandler($event)"
        (camerasFound)="onCamerasFound($event)"
    ></zxing-scanner>

    <ngx-spinner type="ball-scale-multiple" [fullScreen]="false">{{ 'scanner.loading' | translate }}</ngx-spinner>

    </div>

    <app-validation-popup [reset]="reset" [ticketResponse]="ticketResponse" [offline]="offline"></app-validation-popup>
 
</div>
